<template>
    <div class="no__print">
        <q-header v-show="!isShow" reveal class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1">
                        <!-- <b>학습 분석리포트 - {{ headerLearningType }} {{ headerLevel }}레벨 {{ headerLesson }}레슨</b> -->
                        <b>{{ typeLevLes }}</b>
                    </div>
                </div>
<!--                <div v-if="gStore?.platform === 'DESKTOP'">
                    <q-icon name="img:/assets/images/icon/ico_report_print.svg" :onclick="onPrint" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>-->
            </q-toolbar>
        </q-header>
        <q-page-container v-show="!isShow">
            <q-page>
                <ReportContent v-if="reportData" :reportData="reportData" />
            </q-page>
        </q-page-container>
    </div>
    <div class="print_area">
        <PrintReportContent v-if="reportData" :reportData="reportData" :type-lev-les="typeLevLes" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import ReportContent from './reportContent.vue';
import PrintReportContent from './printReportContent.vue';
import { learningType } from '@/helpers/qbankParser/qbankMeta';
import { DialogStore } from '@/store/modules/dialog';
import { getReportSat, getReportArea, getReportAreaSuggestion, getReportDiagnostic } from '@/api/modules/study';
import { GlobalStore } from '@/store';
import { monitoringLog } from '@/api/modules/monitoring';

import Comm from '@/components/common.js';
const comUserName = computed(() => {
    return Comm.getStrName();
});
const comSchoolAndGrade = computed(() => {
    return Comm.getStrSchoolAndGrade();
});
const typeLevLes = computed(() => {
    return '학습 분석리포트 - ' + headerLearningType.value + ' ' + headerLevel.value + '레벨 ' + headerLesson.value + '레슨';
});

const gStore = GlobalStore();
const studyStore = StudyStore();
const router = useRouter();
const store = DialogStore();
const reportData = ref(null);
const isPrintmode = ref(false);
const isShow = ref(false);
const headerLearningType = ref('');
const headerLevel = ref('');
const headerLesson = ref('');
const route = useRoute();

const beforePrint = () => {
    isPrintmode.value = true;
};
const afterPrint = () => {
    isPrintmode.value = false;
};

window.onbeforeprint = beforePrint;

window.onafterprint = afterPrint;

const onPrint = () => {
    // isPrintmode.value = true;
    isPrintmode.value = true;
    setTimeout(() => {
        window.print();
    }, 500);
};

onMounted(() => {
    headerLearningType.value = learningType[studyStore.report?.learningType]?.label;
    headerLevel.value = studyStore.report?.level;
    headerLesson.value = studyStore.report?.lesson;
    if (studyStore.report?.learningHistorySeqs) {
        getReportAreaSuggestion({ learningHistorySeqs: studyStore.report?.learningHistorySeqs }, (rs) => {
            reportData.value = rs;
        });
    } else {
        getReportArea(
            {
                ...studyStore.report,
            },
            (rs) => {
                reportData.value = rs;
            },
        );
    }

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('dailyreport monitoringLog API response ===', res);
    });
});

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};
</script>

<style scoped lang="scss">
.print_area {
    visibility: hidden;
    position: absolute;
    right: 0;
}

.no__print {
    visibility: visible;
    display: block;
}

@media print {
    .no__print {
        visibility: hidden;
        display: none;
    }

    .print_area {
        visibility: visible;
        display: contents;
        margin-bottom: 10px;
    }
}
</style>
